import React from 'react';
import { useCustomLocation, useCustomNavigate } from '../../hooks';

import * as routeNames from '../../routes/routeName';

export const getBreadcrumbRoutes = ({ activeTab = '', search = '' } = {}) => ({
		[routeNames.ADD_PATIENTS]: { label: 'Add Patients', additionalLabel: 'You can add and remove patients as you want.', name: 'Patients' },

		[routeNames.ALL_PATIENTS]: {
			label: search.includes('blister=1') ? 'Blister Patients'
				: search.includes('?status=1') ? 'Active Patients'
				: search.includes('?status=0') ? 'Inactive Patients' : 'Patients',
			additionalLabel: 'You can add and remove patients as you want.', name: 'Patients'
		},

        [routeNames.CHANGE_LOG_ROUTE]: { label: 'Change Log', name: 'Dashboard' },
		[routeNames.PHARMACY_INFORMATION_UPDATE_FORM]: { label: 'Pharmacy Information Update Notification for Clinics', name: 'Forms' },
		[routeNames.PHARMACY_PRESCRIPTION_TRASNSFER_FORM]: { label: 'Rx Transfer Request', name: 'Forms' },
		[routeNames.pharmacy_Emergency_Supply_OAT_medications_form]: { label: 'Dr Notification for Emergency Supply', name: 'Forms' },
		[routeNames.pharmacy_medication_form]: { label: 'Anti-Viral Request Form', name: 'Forms' },
		[routeNames.missing_Rx_Requirements]: { label: 'Missing Rx Requirements', name: 'Forms' },
		[routeNames.pharmacy_emergency_supply_continuity_form]: { label: 'Emergency Supply for Continuity of Care', name: 'Forms' },
		[routeNames.patient_agreement_for_take_home_dosing]: { label: 'Patient Agreement For Take Home Dosing', name: 'Forms' },
		[routeNames.pharmacy_Plan_G_Form]: { label: 'Plan G Form', name: 'Forms' },
		[routeNames.pharmacy_Plan_Z_Form]: { label: 'Plan Z Form', name: 'Forms' },
		[routeNames.pharmacy_doctor_communication_form]: { label: 'Communication Form', name: 'Forms' },
		[routeNames.pharmacy_original_prescription_form]: { label: 'Request Copy of Original Rx for OAT/DD', name: 'Forms' },
		[routeNames.pharmacy_Pharmacist_Prescriber_Communication]: { label: 'Pharmacist Prescriber Communication.', name: 'Forms' },
		[routeNames.pharmacy_doctor_note_form]: { label: 'Doctor Note.', name: 'Forms' },
		[routeNames.pharmacy_tb_skin_test_mantoux_form]: { label: 'TB Skin Test (Mantoux Test) Report Form', name: 'Forms' },
		[routeNames.pharmacy_tb_form]: { label: 'TB Screening Form', name: 'Forms' },
		[routeNames.pharmacy_tb_screening_form_logs]: { label: 'TB Screening Forms Logs', name: 'Forms' },

		[routeNames.pharmacy_all_notifications]: { label: 'All Notifications', name: 'Dashboard' },
		[routeNames.pharmacy_bookmarks]: { label: 'Bookmarks', name: 'Dashboard' },

		[routeNames.pharmacy_order_compounding_form]: { label: 'Compounding Order', name: 'Compound' },
		[routeNames.pharmacy_order_compound_form]: { label: 'Compound Order Form', name: 'Compound' },
		[routeNames.pharmacy_compounds]: { label: 'Price List', name: 'Compound' },
		[routeNames.pharmacy_compound_quotations]: { label: 'Quotation', name: 'Compound' },
		[routeNames.pharmacy_fax_log]: { label: 'Sent Fax Logs', name: 'Dashboard', additionalLabel: 'Manage Your List' },
		[routeNames.pharmacy_compound_agreement_form]: { label: 'Compounding Agreement', name: 'Compound' },
		[routeNames.pharmacy_controlled_order_request]: { label: 'Controlled Substances Order Request Form', name: 'Compound' },
		[routeNames.pharmacy_compound_dins]: { label: 'Add Compound Dins', name: 'Compound' },
		[routeNames.pharmacy_compound_logs]: { label: "Today's Billing", name: 'Compound' },
		[routeNames.pharmacy_compound_due_billing]: { label: 'Due Billing', name: 'Compound' },

		[routeNames.pharmacy_archived_deliveries]: { label: 'Archived Deliveries', name: 'Dispense' },
		[routeNames.pharmacy_create_manual_delivery]: { label: 'Add Medication', name: 'Dispense' },
		[routeNames.pharmacy_route_delivery]: { label: 'Delivery List By Route', name: 'Dispense', additionalLabel: 'You can manage deliveries.' },
		[routeNames.pharmacy_driver]: { label: 'Manage Delivery Driver', name: 'Dispense', additionalLabel: 'You can add and remove delivery drivers as you want.' },
		[routeNames.pharmacy_driver_clinic_call_logs]: { label: 'Driver Clinic Call Logs', name: 'Dispense' },
		[routeNames.pharmacy_deliveries_supervisor]: { label: 'Manage Delivery Supervisors', name: 'Dispense', additionalLabel: 'You can add and remove delivery supervisors as you want.' },
		[routeNames.pharmacy_delivery]: { label: 'Delivery List', name: 'Dispense', additionalLabel: 'You can manage deliveries.' },
		[routeNames.pharmacy_missed_deliveries]: { label: 'Delivery List', name: 'Dispense', additionalLabel: 'You can manage deliveries.' },
		[routeNames.pharmacy_sig_check_ai]: { label: 'Sig Check - AI Alpha', name: 'Dispense' },
		[routeNames.pharmacy_delivery_lables]: { label: 'Delivery Labels', name: 'Dispense' },
		[routeNames.pharmacy_recurrence_delivery]: { label: 'Recurrence Delivery List', name: 'Dispense' },
		[routeNames.pharmacy_expiring_rx]: { label: 'Expiring Rx', name: 'Dispense' },
		[routeNames.pharmacy_expiring_rx_v2]: { label: 'Expiring Rx V2', name: 'Dispense' },
		[routeNames.pharmacy_patient_counselling]: { label: 'Counselling', name: 'Dispense' },
		[routeNames.pharmacy_consent_form_logs]: { label: 'Consent Submissions', name: 'Dispense' },
		[routeNames.pharmacy_drugs_billing]: { label: 'Today Billing', name: 'Dispense' },
		[routeNames.pharmacy_oat_prescriptions]: { label: 'Prescriptions', name: 'Dispense' },
		[routeNames.pharmacy_memo]: { label: 'Memo', name: 'Dispense' },
		[routeNames.upload_prescription]: { label: 'Upload Prescription', name: 'Dispense' },
		[routeNames.pharmacy_ongoing_prescritiptions]: { label: 'Ongoing Prescriptions', name: 'Dispense' },
		[routeNames.pharmacy_returned_patches]: { label: 'Returned Patches', name: 'Dispense' },
		[routeNames.pharmacy_fentanyl_patch_log]: { label: 'Destruction Fentanyl Patches', name: 'INVENTORY' },
		[routeNames.pharmacy_reversed_deliveries]: { label: 'RU/RR/RE Deliveries ', name: 'Dispense' },
		[routeNames.pharmacy_tranfer_patient_concent]: { label: 'Transfer Consents ', name: 'Dispense' },
		[routeNames.pharmacy_accountability]: { label: 'Accountability ', name: 'Dispense' },
		[routeNames.pharmacy_investigate_rx]: { label: 'Investigate RX ', name: 'Dispense' },
		[routeNames.pharmacy_rxnumber_date_sync]: { label: 'Mark Delivered', name: 'Dispense' },
		[routeNames.pharmacy_rx_signature_request_list]: { label: 'Rx Signatures Request ', name: 'Dispense' },
		[routeNames.pharmacy_patient_soap_notes]: { label: 'Med Review', name: 'Dispense' },
		[routeNames.pharmacy_super_nova_verification]: { label: 'Super Nova ', name: 'Dispense' },
		[routeNames.pharmacy_half_baked]: { label: 'Half Baked', name: 'Dispense' },
		[routeNames.pharmacy_med_review_logs]: { label: 'Med Review Logs', name: 'Dispense' },
		[routeNames.pharmacy_create_soap_notes]: { label: 'Create SOAP Notes', name: 'Dispense' },
		[routeNames.pharmacy_soap_notes_logs]: { label: 'Soap Notes Logs', name: 'Dispense' },
		[routeNames.pharmacy_med_review_logs_v2]: { label: 'Med Review Logs V2', name: 'Dispense' },

		[routeNames.pharmacy_patient_blister_pack]: { label: 'Add Patient Blister Pack', name: "Blister's" },
		[routeNames.pharmacy_blister_patients]: { label: 'Patient Blister Pack', name: "Blister's" },
		[routeNames.pharmacy_blister_packs]: { label: 'Blister Packs', name: "Blister's" },
		[routeNames.pharmacy_blister_daily_packs]: { label: "Today's Blister Pack", name: "Blister's" },
		[routeNames.pharmacy_blister_pack_on_shelf]: { label: "Blister Packs on Shelf", name: "Blister's" },
		[routeNames.pharmacy_blister_sheets]: { label: "Blister Sheets", name: "Blister's" },
		[routeNames.pharmacy_blister_sheets_report]: { label: "Blister Sheets Report", name: "Blister's" },

		[routeNames.pharmacy_patient_vials_pack]: { label: "Patient Vials", name: "Vials" },
		[routeNames.pharmacy_add_vials_patient]: { label: "Add Patient Vials Pack", name: "Vials" },
		[routeNames.pharmacy_vials_packs]: { label: "Vials Pack", name: "Vials" },
		[routeNames.pharmacy_dailyvials_packs]: { label: "Today's Vial Pack", name: "Vials" },


		[routeNames.pharmacy_add_medication_patients]: { label: "Patient Sepciality Medication Pack", name: "Sepciality Medication" },
		[routeNames.pharmacy_speciality_pack]: { label: "Patient Sepciality Medication Pack", name: "Sepciality Medication" },
		[routeNames.pharmacy_speciality_medication_packs]: { label: "Sepciality Medication", name: "Sepciality Medication" },
		[routeNames.pharmacy_dailymedication_packs]: { label: "Today's Speciality Medication Pack", name: "Sepciality Medication" },
		[routeNames.pharmacy_generate_invoice]: { label: "Generate Invoice", name: "Invoice" },
		[routeNames.pharmacy_previous_invoices]: { label: "Previous Invoice", name: "Invoice" },

		[routeNames.ADD_ARV]: { label: 'Add ARV', name: 'ARV' },
		[routeNames.ARV_LIST]: { label: 'ARV Lists', name: 'ARV' },

		[routeNames.pharmacy_daily_revenue]: { label: 'Pharmacy Daily Revenue', name: 'Revenue' },
		[routeNames.pharmacy_cash_change]: { label: 'Pharmacy Cash Change', name: 'Revenue' },
		[routeNames.pharmacy_deposit_info]: { label: 'Pharmacy Deposit Info', name: 'Revenue' },
		[routeNames.pharmacy_hand_cash]: { label: 'Pharmacy In Hand Cash', name: 'Revenue' },

		[routeNames.create_new_fda_form]: { label: 'Create New FDA', name: 'FDA FORM' },
		[routeNames.all_generated_fda_form_list]: { label: "All Generated FDA's", name: 'FDA FORM' },
		[routeNames.pharmacy_expiring_frequent_dispense]: { label: "Expiring FDA's", name: 'FDA FORM' },
		[routeNames.pharmacy_expired_frequent_dispense]: { label: "Expired FDA's", name: 'FDA FORM' },
		[routeNames.pharmacy_fda_audit]: { label: "FDA Audit", name: 'FDA FORM' },
		[routeNames.pharmacy_frequent_dispensing_authorization_timeline]: { label: "FDA Doctor Timelines", name: 'FDA FORM' },

		[routeNames.pharmacy_inventory_list]: { label: "Inventory List", name: 'INVENTORY' },
		[routeNames.pharmacy_fridge_temperature_log]: { label: "Fridge Temperature", name: 'INVENTORY' },
		// [routeNames.pharmacy_total_reversed]: { label: "Total Reversed", name: 'INVENTORY' },

		[routeNames.pharmacy_patient_route]: { label: "Routes", name: 'Patients' },
		[routeNames.pharmacy_add_patient_route]: { label: "Add Patient Route", name: 'OAT' },
		[routeNames.pharmacy_reminder_notes]: { label: "Reminder Notifications", name: 'Dashboard' },
		[routeNames.pharmacy_delivered_rx_reasons]: { label: 'Delivered RX Reasons', name: 'Dashboard' },

		[routeNames.pharmacy_add_travel_pack]: { label: "Travel Patients", name: 'Travel' },
		[routeNames.pharmacy_add_travel_patient]: { label: "Add Patients", name: 'Travel' },
		[routeNames.pharmacy_travel_logs]: { label: "Travel Logs", name: 'Travel' },
		[routeNames.pharmacy_billing_due]: { label: "Billing Due", name: 'Travel' },
		[routeNames.pharmacy_travel_returning_patients]: { label: "Return Date", name: 'Travel' },

		// [routeNames.pharmacy_app_prescriptions]: { label: "Prescriptions", name: 'App', additionalLabel: 'You can manage prescription requests.' },
		// [routeNames.pharmacy_order_transfer]: { label: "Prescriptions", name: 'App', additionalLabel: 'You can manage prescription requests.' },
		// [routeNames.pharmacy_order_new]: { label: "Prescriptions", name: 'App', additionalLabel: 'You can manage prescription requests.' },
		// [routeNames.pharmacy_app_user_list]: { label: "App User", name: 'App', additionalLabel: 'You can manage user' },
		// [routeNames.pharmacy_app_refill_request]: { label: 'Prescriptions', name: 'App', additionalLabel: 'You can manage prescription requests.' },
		// [routeNames.pharmacy_app_announcements]: { label: "App Announcements", name: 'App', additionalLabel: 'You can manage your Announcements' },
		// [routeNames.pharmacy_app_notification_list]: { label: "Custom Notification", name: 'App', additionalLabel: 'You can manage your Notification' },
		// [routeNames.pharmacy_app_pharmacy_services]: { label: "Pharmacy Services", name: 'App', additionalLabel: 'You can manage services shown in the mobile app.' },
		// [routeNames.pharmacy_app_pharmacy_services_alias]: { label: "Pharmacy Services", name: 'App', additionalLabel: 'You can manage services shown in the mobile app.' },
		
		[routeNames.pharmacy_tb_skin_test_logs]: { label: 'TB Skin Test Logs', name: 'Forms' },
		[routeNames.pharmacy_tasks_list]: { label: 'TASKS LIST', name: 'DASHBOARD' },

		[routeNames.pharmacy_appointment_logs]: { label: 'Appointment Logs', name: 'Appointments' },
		[routeNames.pharmacy_juno_appointment]: { label: 'Book Appointments', name: 'Appointments' },

		// ------------AdminBreadCrumbs------------------
		[routeNames.pharmacy_timeoff]: { label: 'TIME OFF REQUEST', name: 'TEAM' },
		[routeNames.pharmacy_create_new_task]: { label: 'CREATE NEW TASK', name: 'TEAM' },
		[routeNames.pharmacy_tasks]: { label: 'TASKS LIST', name: 'TEAM' },
		[routeNames.pharmacy_team_attendance]: { label: 'TIME SHEET', name: 'TEAM' },
		[routeNames.pharmacy_certificate_template]: { label: 'VIEW CERTIFICATE TEMPLATE', name: 'TEAM' },
		[routeNames.pharmacy_check_out_in]: { label: 'Check In Out Logs', name: 'TEAM' },
		[routeNames.pharmacy_break_parroll_settings]: { label: 'Break/Payroll Setting', name: 'Settings' },
		[routeNames.pharmacy_admin_payroll]: { label: 'BookKeeper', name: 'Accountability' },
		[routeNames.pharmacy_accounts]: { label: 'Financials', name: 'Accountability' },
		[routeNames.pharmacy_assign_certificate]: { label: 'EMPLOYEE CERTIFICATES', name: 'TEAM' },
		[routeNames.pharmacy_assign_certificate_employee]: { label: 'ASSIGN CERTIFICATE', name: 'TEAM' },
		[routeNames.pharmacy_department]: { label: 'DEPARTMENTS', name: 'TEAM' },
		[routeNames.pharmacy_user]: { label: 'Manage Users', name: 'TEAM', additionalLabel: 'You can add and remove users as you want.' },
		[routeNames.pharmacy_settings]: { label: 'Settings', name: 'Settings' },

		[routeNames.pharmacy_team_avalibility]: { label: 'Team Schedule', name: 'Team' },
		[routeNames.pharmacy_task_management]: { label: 'Task Management', name: 'Dashboard' },
		[routeNames.pharmacy_vaccine_passport]: { label: 'Patient Vaccine', name: 'Vaccine', additionalLabel: 'Search and manage patient vaccination records' },
		[routeNames.pharmacy_vaccine_logs]: { label: 'Patient Vaccine Logs', name: 'Vaccine', additionalLabel: 'Search and manage patient vaccination records' },

		[routeNames.pharmacy_blister_packaging_processing]: { label: 'Create New Order From Pacmed', name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_prn_processing]: { label: 'PRN Processing', name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_liquid_processing]: { label: 'Liquid Processing', name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_orders]: { label: activeTab, name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_invoices]: { label: 'Invoices', name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_packmed_files]: { label: 'My PACMed Files', name: 'Blister Packaging' },
		[routeNames.pharmacy_blister_packaging_monthly_invoice]: { label: 'Monthly Invoice', name: 'Blister Packaging' },

		[routeNames.pharmacy_accountability_today_missed_rx]: { label: 'Actions', name: 'Accountability' },
		[routeNames.pharmacy_accountability_new_rx]: { label: 'Accountability New Rx', name: 'Accountability' },
		[routeNames.pharmacy_accountability_prep_check]: { label: 'Prep Check', name: 'Accountability' },
		[routeNames.pharmacy_accountability_pickup_log]: { label: 'Pickup Log', name: 'Accountability' },
		[routeNames.pharmacy_accountability_final_check]: { label: 'Final Check', name: 'Accountability' },
		[routeNames.pharmacy_accountability_all_reports]: { label: 'Reports', name: 'Accountability' },
		[routeNames.pharmacy_accountability_prep_for_new_rx]: { label: 'Prep for New Rx', name: 'Accountability' },
		[routeNames.pharmacy_erx]: { label: 'ERx', name: 'Accountability' },
		[routeNames.pharmacy_mark_flexi]: { label: 'Mark Flexi', name: 'Accountability' },
		[routeNames.pharmacy_accountability_after_process_prep_check]: { label: 'After Process Prep Check', name: 'Accountability' },
		[routeNames.pharmacy_pharmacare]: { label: 'Pharmacare', name: 'Accountability' },

		[routeNames.pharmacy_packaging_processing]: { label: activeTab, name: 'Packaging' },
		[routeNames.pharmacy_packaging_orders]: { label: activeTab, name: 'Packaging' },
		[routeNames.pharmacy_packaging_all_d_logs]: { label: 'My PACMed Files', name: 'Packaging' },
		[routeNames.pharmacy_packaging_din_management]: { label: 'DIN Management', name: 'PACMed' },
		[routeNames.pharmacy_packaging_invoices]: { label: 'Invoices', name: 'Packaging' },
		[routeNames.pharmacy_packaging_prn_processing]: { label: 'Packaging PRN Processing', name: 'Packaging' },
		[routeNames.pharmacy_packaging_liquid_processing]: { label: 'Packaging Liquid Processing', name: 'Packaging' },
		[routeNames.pharmacy_packaging_order_preview]: { label: 'Order Preview', name: 'Packaging' },
		[routeNames.pharmacy_packaging_monthly_invoice]: { label: 'Monthly Invoice', name: 'Packaging' },


		[routeNames.pharmacy_packaging_analytics]: { label: 'Analytics', name: 'Packaging' },


		[routeNames.PHARMACY_PATIENT_PROFILE]: {
			label: `${activeTab === 'Profile' ? 'Patient Profile' : activeTab === 'HCP' ? ' HCP' : activeTab
				}`, name: 'Patient'
		},
	});

export const BreadCrumb = ({ activeTab }) => {

	const location = useCustomLocation();
	const navigate = useCustomNavigate();

	const routes = getBreadcrumbRoutes({ activeTab, search: location.search });

	const currentRoute = routes[location.pathname];

	return (
		<div className="grid grid-cols-12 gap-4">
			<div className="mt-5 sm:mt-5 md:mt-5 lg:mt-0 col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12">
				<nav className="flex " aria-label="Breadcrumb">
					<ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
						<li className="inline-flex items-center">
							<a
								onClick={() => {
									if (currentRoute) {
										const firstRoute = Object.values(routes).find(route => route.name === currentRoute.name);
										if (firstRoute) {
											const routeKey = Object.keys(routes).find(key => routes[key] === firstRoute);
											navigate(routeKey);
										}
									}
								}}
								className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white cursor-pointer"
							>
								{currentRoute && currentRoute.name}
							</a>
						</li>

						<li>
							<div className="flex items-center">
								{currentRoute &&
									<svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
										<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
									</svg>
								}
								{currentRoute && (
									<a className="ms-1 text-sm font-medium text-blue-600  hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white">
										{currentRoute.label}
									</a>
								)}
							</div>
						</li>
					</ol>
				</nav>
				{currentRoute && currentRoute.additionalLabel && <p className="fs-14 rubik-400">{currentRoute.additionalLabel}</p>}
			</div>
		</div>
	);
};
